import { defineStore } from "pinia";
import { WhoAmIAPI } from "@/utils/generated/api-auth";
import { useLocaleStore } from "./localeStore";

export const useAuthStore = defineStore("auth", () => {
  /** @type {Ref<Awaited<ReturnType<typeof WhoAmIAPI.whoAmI>>>} */
  const me = ref();
  async function authenticate() {
    me.value = await WhoAmIAPI.whoAmI();
    if (me.value) useLocaleStore().locale = me.value.locale;
    return me.value;
  }

  const isAppAdmin = computed(() => me.value?.features?.some((f) => f.includes("APPLICATIONOWNER")));
  const isCharityAdmin = computed(() => me.value?.features?.some((f) => f.includes("CHARITY")));
  const SUPERADMIN_FEATURE = "ROLE_FUNDRAISING_APPLICATIONOWNER_PAYMENT";
  const isSuperAdmin = computed(() => me.value?.features?.includes(SUPERADMIN_FEATURE) ?? false);

  /** @param {string | number} billingId */
  function canAccessDashboard(billingId) {
    if (!me.value?.features) return false;
    if (me.value.features.includes("ROLE_FUNDRAISING_APPLICATIONOWNER_PAYMENT")) return true;
    return me.value.features.includes("ROLE_FUNDRAISING_ORGANIZATION_PAYMENT") && me.value.idCharity === Number(billingId);
  }

  return { me, authenticate, isAppAdmin, isCharityAdmin, isSuperAdmin, canAccessDashboard };
});
